<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>Banner设置</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="query.type"
                placeholder="请选择"
                @change="handleQueryChange('type', $event)"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in bannerTypes"
                  :key="item.type"
                  :label="item.message"
                  :value="item.type"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="query.language"
                placeholder="请选择"
                @change="handleQueryChange('language', $event)"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in languageList"
                  :key="item.intCode"
                  :label="item.language"
                  :value="item.intCode"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <div class="ipt">
              <el-select
                v-model="query.platform"
                placeholder="请选择"
                @change="handleQueryChange('platform', $event)"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in platformTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="query.subjectType"
                placeholder="请选择"
                @change="handleQueryChange('subjectType', $event)"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in subjectTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <create-banner @refresh="refreshList"></create-banner>
      </div>
      <banner-list @refresh="refreshList"></banner-list>
    </el-card>
  </div>
</template>

<script>
import './store'
import BannerList from './components/list'
import CreateBanner from './components/create'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'BannerSetting',
  components: {
    BannerList,
    CreateBanner,
  },
  computed: {
    ...mapState('settingBanner', [
      'platformTypeList',
      'subjectTypeList',
      'languageList',
      'query',
      'bannerTypes',
      'tentIdlist',
    ]),
  },
  methods: {
    ...mapActions('settingBanner', [
      'list',
      'getbannerType',
      'getTentIdlist',
      'getLanguageList',
    ]),
    ...mapMutations('settingBanner', ['changeQuery']),
    refreshList() {
      this.list(this.query)
    },
    handleQueryChange(type, value) {
      this.changeQuery({
        ...this.query,
        [type]: value,
      })
      this.refreshList()
    },
  },
  created() {
    this.list(this.query)
    this.getbannerType()
    this.getLanguageList()
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped></style>
